import { z } from "zod/v4";
const KanaSchema = z
    .string()
    .regex(/^[0-9\u30A0-\u30FF\s()]+$/, "カタカナで入力してください。")
    .brand();
export const Kana = {
    schema: KanaSchema,
};
//# sourceMappingURL=kana.js.map